import type {ComboboxItem} from '@mantine/core';
import React, {useMemo} from 'react';
import type {
  NotificationRuleCourseChangeTypeEnum,
  NotificationRuleMetadata} from 'src/api/ProactApiClient';
import {
  NotificationRuleChangeTypeEnum
} from 'src/api/ProactApiClient';
import {getConfigForChangeType} from '../config/changeEventConfig';
import {ChangeEventConditionList} from './ChangeEventConditionList';

export interface EditNotificationChangeEventRulesProps {
  data: NotificationRuleMetadata;
  onDataChange(data: NotificationRuleMetadata): void;
  disabled: boolean;
  attachmentClassificationOptions?: ComboboxItem[];
  attachmentTypeOptions?: ComboboxItem[];
}

/**
 * Router component for change event rules.
 * Uses configuration lookup to determine which module config to use,
 * then renders the generic ChangeEventConditionList with that config.
 */
export const EditNotificationChangeEventRules: React.FC<
  EditNotificationChangeEventRulesProps
> = ({data, onDataChange, disabled, attachmentClassificationOptions, attachmentTypeOptions}) => {
  const changeType = Number(data.changeType) as NotificationRuleChangeTypeEnum;
  const courseChangeType = Number(
    data.courseChangeType
  ) as NotificationRuleCourseChangeTypeEnum;

  const config = useMemo(() => {
    const result = getConfigForChangeType(
      changeType,
      courseChangeType,
      attachmentClassificationOptions,
      attachmentTypeOptions
    );
    if (!result && changeType !== NotificationRuleChangeTypeEnum.Invalid) {
      console.error('Unexpected notification rule change type: ', changeType);
    }
    return result;
  }, [changeType, courseChangeType, attachmentClassificationOptions, attachmentTypeOptions]);

  if (!config) {
    return null;
  }

  return (
    <ChangeEventConditionList
      config={config}
      metadata={data}
      onMetadataChange={onDataChange}
      disabled={disabled}
    />
  );
};
